import { configureStore } from '@reduxjs/toolkit';
import styleReducer from './styleSlice';
import mainReducer from './mainSlice';
import authSlice from './authSlice';
import openAiSlice from './openAiSlice';

import usersSlice from "./users/usersSlice";
import rolesSlice from "./roles/rolesSlice";
import permissionsSlice from "./permissions/permissionsSlice";
import teachersSlice from "./teachers/teachersSlice";
import school_yearsSlice from "./school_years/school_yearsSlice";
import semestersSlice from "./semesters/semestersSlice";
import classesSlice from "./classes/classesSlice";
import studentsSlice from "./students/studentsSlice";
import homeroom_daily_journalsSlice from "./homeroom_daily_journals/homeroom_daily_journalsSlice";
import religious_guidance_journalsSlice from "./religious_guidance_journals/religious_guidance_journalsSlice";
import quran_surahsSlice from "./quran_surahs/quran_surahsSlice";
import quran_versesSlice from "./quran_verses/quran_versesSlice";
import memorization_depositsSlice from "./memorization_deposits/memorization_depositsSlice";
import memorization_verse_assessmentsSlice from "./memorization_verse_assessments/memorization_verse_assessmentsSlice";
import memorization_targetsSlice from "./memorization_targets/memorization_targetsSlice";
import murojaah_sessionsSlice from "./murojaah_sessions/murojaah_sessionsSlice";
import murojaah_verse_assessmentsSlice from "./murojaah_verse_assessments/murojaah_verse_assessmentsSlice";
import memorization_reportsSlice from "./memorization_reports/memorization_reportsSlice";

export const store = configureStore({
  reducer: {
    style: styleReducer,
    main: mainReducer,
    auth: authSlice,
    openAi: openAiSlice,

users: usersSlice,
roles: rolesSlice,
permissions: permissionsSlice,
teachers: teachersSlice,
school_years: school_yearsSlice,
semesters: semestersSlice,
classes: classesSlice,
students: studentsSlice,
homeroom_daily_journals: homeroom_daily_journalsSlice,
religious_guidance_journals: religious_guidance_journalsSlice,
quran_surahs: quran_surahsSlice,
quran_verses: quran_versesSlice,
memorization_deposits: memorization_depositsSlice,
memorization_verse_assessments: memorization_verse_assessmentsSlice,
memorization_targets: memorization_targetsSlice,
murojaah_sessions: murojaah_sessionsSlice,
murojaah_verse_assessments: murojaah_verse_assessmentsSlice,
memorization_reports: memorization_reportsSlice,
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch
